import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import NewsFeed from './components/NewsFeed';
import ArticleDetail from './components/ArticleDetail';
import EventDetail from './components/EventDetail';
import Admin from './components/Admin';
import './App.css';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

function App() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    // Load stats
    fetch(`${API_URL}/api/stats`)
      .then(res => res.json())
      .then(data => setStats(data))
      .catch(err => console.error('Stats error:', err));
    
    // Refresh stats every 30 seconds
    const interval = setInterval(() => {
      fetch(`${API_URL}/api/stats`)
        .then(res => res.json())
        .then(data => setStats(data))
        .catch(err => console.error('Stats error:', err));
    }, 30000);
    
    // AGGRESSIVELY remove Emergent badge
    const removeBadge = () => {
      // Remove any links to emergentagent
      document.querySelectorAll('a[href*="emergentagent"]').forEach(el => {
        el.style.display = 'none';
        el.remove();
      });
      
      // Remove any fixed positioned elements in bottom right
      document.querySelectorAll('*').forEach(el => {
        const style = window.getComputedStyle(el);
        if (style.position === 'fixed') {
          const rect = el.getBoundingClientRect();
          if (rect.bottom > window.innerHeight - 100 && rect.right > window.innerWidth - 300) {
            el.style.display = 'none';
            el.remove();
          }
        }
      });
    };
    
    // Run immediately and every second
    removeBadge();
    const badgeInterval = setInterval(removeBadge, 1000);
    
    return () => {
      clearInterval(interval);
      clearInterval(badgeInterval);
    };
  }, []);

  return (
    <Router>
      <div className="app">
        {/* Header */}
        <header className="app-header">
          <div className="container">
            <div className="header-content">
              <Link to="/" className="logo">
                <span className="logo-icon">🌐</span>
                <span className="logo-text">My News Feed</span>
                <span className="auto-monitor-badge">🤖 Auto-Monitoring</span>
              </Link>
              
              <nav className="nav">
                <Link to="/" className="nav-link">Feed</Link>
                {stats && (
                  <div className="stats-badge">
                    <span className="stat-item">{stats.total_articles} Articles</span>
                    <span className="stat-separator">•</span>
                    <span className="stat-item">{stats.total_events} Events</span>
                  </div>
                )}
              </nav>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="app-main">
          <Routes>
            <Route path="/" element={<NewsFeed />} />
            <Route path="/article/:id" element={<ArticleDetail />} />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="app-footer">
          <div className="container">
            <p>© 2026 AI-Powered News Platform | All articles are AI-generated</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
